import { Box, MenuItem, Select, Typography } from '@mui/material';
import React from 'react'
import { ReqField } from '../CustomComponents/CustomLoader';

const SelectInputs = ({ title, name, value, handleChange, options, required, optionTitle, optionValue }) => {
    return (
        <Box>
            <Typography
                variant="subtitle1"
                fontWeight={600}
                component="label"
                htmlFor={name}
                mb="5px"
            >
                {title} {required !== false && <ReqField />}
            </Typography>
            <Select
                fullWidth
                labelId={name}
                id={name}
                size="medium"
                mt="25"
                value={value}
                name={name}
                onChange={handleChange}
            >
                {options?.map((item, index) => {
                    return <MenuItem value={item[optionValue]} key={index}>{item[optionTitle]}</MenuItem>
                })}
            </Select>
        </Box>
    )
}

export default SelectInputs
